import React from 'react';
import { Report } from 'types/report';
import Panel from '../../../Panels';
import ResidentialAddresses from './ResidentialAddresses';
import DisclosedAliases from './DisclosedAliases';

interface AdditionalInformationProps {
  report: Report;
}

const AdditionalInformation: React.FC<AdditionalInformationProps> = ({
  report,
}) => {
  const residentialAddresses = report.candidateDisclosedAddresses;
  const disclosedAliases = report.candidateDisclosedAliases;

  // Only show the section if there are addresses or aliases to display
  if (
    (!residentialAddresses || residentialAddresses.length === 0) &&
    (!disclosedAliases || disclosedAliases.length === 0)
  ) {
    return null;
  }

  const hasAliases = disclosedAliases && disclosedAliases.length > 0;
  const hasAddresses = residentialAddresses && residentialAddresses.length > 0;

  return (
    <Panel
      data-testid='additional-information-panel'
      className='card-information'
      title='Additional information from you'
    >
      {hasAliases && <DisclosedAliases aliases={disclosedAliases} />}
      {hasAliases && hasAddresses && <hr className='my-4' />}
      {hasAddresses && (
        <ResidentialAddresses
          addresses={residentialAddresses}
          lookbackYears={report.addressHistoryLookbackYears}
        />
      )}
    </Panel>
  );
};

export default AdditionalInformation;
